import * as React from 'react';
import { PropertyManagerViewModel } from 'models';
import { PropertyDetailsSegment } from './property-details-segment';
import { UitkFigure, UitkFigureAspectRatioType, UitkQueuedImage } from 'uitk-react-images';

interface PropertyManagerProps {
  propertyManager?: PropertyManagerViewModel;
}

export const PropertyManager: React.FunctionComponent<PropertyManagerProps> = ({ propertyManager }) =>
  Boolean(propertyManager) && (
    <PropertyDetailsSegment
      dataStid="section-property-manager"
      errorBoundaryLabel="hotel.information.policies.propertyManager"
      rootClassName="property-manager"
      title={propertyManager.title}
      isToggleHidden={true}
    >
      <div className="uitk-grid">
        {propertyManager.photo && (
          <div className="all-cell-1-6 all-r-padding-three all-y-padding-three uitk-cell">
            <UitkFigure ratio={UitkFigureAspectRatioType.R1_1} className="all-image-fit-contain">
              <UitkQueuedImage src={propertyManager.photo.src} alt={propertyManager.photo.caption} />
            </UitkFigure>
          </div>
        )}
        <div className="uitk-cell all-cell-fill all-y-padding-three">
          <h4 className="policies__header--secondary uitk-type-heading-500 uitk-type-bold">{propertyManager.name}</h4>
          {propertyManager.languagesSpoken && <p className="uitk-type-paragraph-300">{propertyManager.languagesSpoken}</p>}
        </div>
      </div>
    </PropertyDetailsSegment>
  );
